module.exports = __webpack_public_path__ + "img/31D.fd481432.png";